import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChainPartnership } from '~/pages/Chain/Partnership/ChainPartnership';
import type { ChainPartnershipProps } from '~/types/Chain';

import '~/styles/main.scss';

interface WindowWithData extends Window {
  data: ChainPartnershipProps;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const data = (window as unknown as WindowWithData).data || {};

root.render(
  <React.StrictMode>
    <ChainPartnership {...data} />
  </React.StrictMode>
);
